import { connect } from 'react-redux'
import { state_update } from '../actions'
import AiToolbar from './AiToolbar'
import calcPrice from '../reducers/calcPrice'
import ReactGA from 'react-ga';
import {ALL_STONES,ADD_TO_CART_URL,ADD_TO_CART_URL_PROD,ADD_TO_CART_URL_PROD_CHARM,ADD_TO_CART_URL_CHARM,MSG_NOT_READY_ADD_TO_CART,DEFAULT_STATE_VALUE,MSG_NO_SESSION1, MSG_NO_SESSION2, UPDATE_QSKU_URL} from '../constants'; 
const showMessage =(dispatch,data)=>{
  dispatch(state_update({attr:'message',value:data}))
}
const all_stones = [ 'c','s1', 's2', 's3', 's4', 's5', 's6', 's7', 's8', 's9', 's10',
'a1', 'a2', 'a3', 'a4', 'a5', 'a6', 'a7', 'a8', 'a9', 'a10',
]

const getclist =(state)=>{
  var clistqty= 0
  var clist=''
 // if (state.m !=='no' && state['locket'] !=='no'&& state['m'] !=='-1'){
 //   clist = '10|'+state.s +'|'+state.m + "|"
 // }
 //  else if (['9083','9001'].includes(state['locket']))
 //     clist = '20|'+state['locket'] +'|'+state.m + "_"
    if (['9300','9000'].includes(state['chain']) && state.m !=='-1'  && state.m !=='no' ){
      //console.log('clist 777',clist,state.m,state.chain)
      clist = '0|'+state['chain'] +'|'+state.m + "_"
    }  
    //else if   (state.m !=='-1')
    //  clist = '0|'+state.s +'|'+state.m + "_"
    
    if (state['clist']!=='-1'){
      clistqty+=state['clist'].split('_').length
      clist+=state['clist']
    }
    var clist2='' 
   // console.log('clist 777',clist,state.m,state.chain)
     // let cur_image_url =imageLogic(state);
    if (state['acharm'] !=='-1' && state['acat'] !=='-1' )
       if (state['acat'] !=='2' || (state['acat'] ==='2' && state['e1']!==''  && state.s === '9000')|| (state['acat'] ==='2' && state.s !== '9000') )
       {
           clistqty+=1
           //if (clist2 !=='') clist2+='_'
           clist2+=state['acat']+'|'+state['acharm']+'|'+state['am']
          if (state['acat']==='1')
                   clist2 += '|'+state['ai']
          if (state['acat']==='2')
                   clist2 += '|'+state['e1']
          if (state['acat']==='11')
                   clist2 += '|'+state['f']+'|'+state['e1']+'|'+state['e2']
                   
       }   
       //console.log('clistqty1',clist,clist2)
       if (clist2 !=='')
        clist+='_'+ clist2
      return [clist,clistqty]
  
}

const addToCartOptions =(state)=>{
  //console.log('check',state)
  let all_addcart_options= []
  let engr_exist=false
  for (let opt in state['options_all']) {
    if (ALL_STONES.indexOf(state['options_all'][opt]) !== -1) {
      if (state[state['options_all'][opt]] !== DEFAULT_STATE_VALUE &&
      state['options_'+state['options_all'][opt]].show ) //possible but with missing stones in cfg - still bug
        all_addcart_options.push(state['options_all'][opt])
    }
    else if (state['options_all'][opt] ==='e') {
      let all_eng =['e1','e2','e3','e4','e5','e6','e7','e8']
      for (let i1 in all_eng) {
        if (state[all_eng[i1]] )
        all_addcart_options.push(all_eng[i1])
      }
      engr_exist=true
    }
    else {
      all_addcart_options.push(state['options_all'][opt])
    }
 }
 let general_options =['action','hc','hu','hs','he','cfg','sku','style','zsku','title','description','m','bl','cl','isposterminal','esaselected']  
  for (let new_opt in general_options) {
    if (state[general_options[new_opt]]!== DEFAULT_STATE_VALUE)
     all_addcart_options.push(general_options[new_opt])
  }
  let default_options =['m','bl','cl']  
   for (let new_opt in default_options) {
     if (state[default_options[new_opt]] !== DEFAULT_STATE_VALUE && state.hasOwnProperty('option_all') && state['options_all'].indexOf(default_options[new_opt])  === -1) {
      all_addcart_options.push(default_options[new_opt])
     }

  }
  let res={}
  res['site']= window.currentSite
  res['env']= window.currentEnv
  let port = window.location.port
  //console.log('PORT',port)  
   
  if (port !== '80' && port !== '' ) {
    port = ':' + port
  }
  else {
    port =''
  }
 // console.log('engr',engr_exist,state['f'])  
  if (engr_exist)
  {
    res['f']= state['f'] 
  }
 var total_stone_option = []
 var used_stone_option = []
 var missing_stone_option = []
 var sc=parseInt(state['sc'],10)
 if (sc >0 && state['options_all'].indexOf('sc') !== - 1){
  //console.log('sc check',sc)  
  for (let opt in state['options_all']) {
   if (all_stones.indexOf(state['options_all'][opt]) !== - 1)
   {
    total_stone_option.push(state['options_all'][opt])
     
   }
  }
  /*const all_stones1 = [ 'c','s1', 's2', 's3a', 's4', 's5', 's6', 's7', 's8', 's9', 's10',
  'a1', 'a2', 'a3', 'a4', 'a5', 'a6', 'a7', 'a8', 'a9', 'a10',
  ]*/
  
  for (let j in all_addcart_options) {
    if (all_stones.indexOf(all_addcart_options[j]) !== - 1)
    {
     used_stone_option.push(all_addcart_options[j])
    }
  }

  if (all_addcart_options.indexOf('sc') !== -1){
    if ( sc !== used_stone_option.length ){
     //   var diff =parseInt(sc) - used_stone_option.length
        missing_stone_option = total_stone_option.slice(used_stone_option.length,sc)
        //console.log('slice',used_stone_option.length,sc)
    }
  }
  if (missing_stone_option.length >0)
  {
    for (let opt in missing_stone_option) {
          all_addcart_options.push(missing_stone_option[opt])
       //   console.log('added',missing_stone_option[opt])
          
        if (state[missing_stone_option[opt]] === DEFAULT_STATE_VALUE)
          {
            //console.log('real problem with ',missing_stone_option[opt],state[missing_stone_option[opt]],state['options_'+missing_stone_option[opt]].show)
            ReactGA.event({
              category: 'Error',
              action: missing_stone_option[opt]
            });
          }
          else{
            ReactGA.event({
              category: 'Error Fixed',
              action: missing_stone_option[opt]
            });
          }
      
      }
     // console.log('Missing',sc,total_stone_option,used_stone_option,missing_stone_option)
  }
  
 }
  /*if (all_addcart_options.indexOf('sc') != -1)
  {
   for (let j in all_addcart_options) {
     res[all_addcart_options[j]]= state[all_addcart_options[j]] 
   }
  }*/
  res['shopping_url']=window.location.hostname +port
  for (let j in all_addcart_options) {
      res[all_addcart_options[j]]= state[all_addcart_options[j]] 
    }
  res['price']=calcPrice(state)
  state['price']=res['price']
  if (state.sku==='9000'){
    var clistclistqty= getclist(state)
  res['clist']=clistclistqty[0]
  res['chain']=state.chain
  }
  return res
}
const checkSession =(state)=>{
  if (state['hc'] === DEFAULT_STATE_VALUE || state['hc'] === DEFAULT_STATE_VALUE || state['hc'] === DEFAULT_STATE_VALUE  )
    return false
 // console.log('session true')  
  return true  
  
}

const checkOptions =(state)=>{
  //console.log('checkOptions',state)
  if (state.sku ==='9000'){
    if (state.clist === '-1' && state.acharm === '-1' && ( state.chain ==='no' || state.chain === '-1' || (state.chain !== '-1' && state.m === '-1')) )   
      return false
    else  
    return true
  }
  
      if (state.options_e) {
    if (["monogram","nameplate","nameplate2" ].includes(state.options_e.filter)) {  
      var requiredEngs = []
      
      // Check if 'i' is required
      if (state.options_all && state.options_all.includes('i')) {
        requiredEngs.push('i')
      }
      
      // Check which engraving fields are required
        for (let eng of ['e1','e2','e3','e4','e5','e6','e7','e8']) {
          const matchingOption = state.options_e.options.find(opt => opt.attr === eng)
          
          // If option exists and is shown, it's required
          if (matchingOption && matchingOption.show) {
            requiredEngs.push(eng)
          }
        }
      
      // Check if all required fields have values
      if (!requiredEngs.every(eng => state[eng]))
        return false
    }
      }

    for (let j in state.options_all) {

      //if (state["reqCharE1"] === 'yes' && state['e1'] ==='')
        //return false
     // console.log('check',state.options_all[j])
      if (state['options_'+state.options_all[j]].show 
          && state[state.options_all[j]] === DEFAULT_STATE_VALUE
          && (['e','f'].indexOf(state.options_all[j]) === -1  || (['e'].indexOf(state.options_all[j]) === -1) && ([11,12,13].includes(parseInt(state['f'],10))))) { 
   //   console.log('checkOptions false',state.options_all[j],state['options_'+state.options_all[j]].show,state[state.options_all[j]] === DEFAULT_STATE_VALUE) 
      return false
     }
    }
   // console.log('checkOptions true')
  return true
}

const addToCart =(dispatch,param)=>{
  //console.log('start add to cart',param)
  if (window.add2cart==='sent'  )
    return
  window.add2cart='sent'  
ReactGA.event({
  category: 'AddToCart',
  action:'AddToCart' 
});

  let header = new Headers({
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'multipart/form-data'
  });
  let sentData = {
    //method: 'GET', 
    method: 'POST', 
      mode: 'cors',
      header: header,
      body: JSON.stringify(param)
      //    body:opt.body || ''
  };
  let fetchUrl =ADD_TO_CART_URL
  
  if (window.currentEnv ==='www' ||window.currentEnv ==='prod2' ){
    fetchUrl =ADD_TO_CART_URL_PROD
  }
  if (['9000','9082'].includes(param['sku'])){
    fetchUrl =ADD_TO_CART_URL_CHARM
    if (window.currentEnv ==='www' ||window.currentEnv ==='prod2' ){
      fetchUrl =ADD_TO_CART_URL_PROD_CHARM
    }
      
  }
   // console.log('add to cart refresh',param)
          
    let sku =param.style
    let skuPrice = param.price
    let nexusSite = window.currentSite
    let nexusSiteTitle = nexusSite.substring(0,1).toUpperCase() + nexusSite.slice(1)
    // 2000 for Kay, 2032 for KayOutlet, 2001 for Jared, 0008 for ZalesOutlet
    //let stext1 = 'window.adobeDataLayer.push({'+
    var dataLayer = new Object();dataLayer = {"cart": {"cartID": param.hc},
      "event":"cartItemAddition",
  "product": {"productListItems":[{"baseProduct":"V-" + sku ,"brand":nexusSite,  "description":"","inventoryLevel":"","origPrice":skuPrice,"outOfStock":"","parentProduct":"","personalization":"",
  "productCategory":"Custom Personalized","productClass":"","productName":"Personalized Configurator","productSKU": sku,"quantity":"1","rating": "","ratingCount":"","salePrice":skuPrice,"startingPrice":skuPrice,
  "title":nexusSiteTitle	}]},
  "user": {"asmLoggedIn":"false","city":"","country":"","email":"anonymous","guestID":"","lastLoginDate":"","loginMethod":"","loginSuccess":"","loyaltyID":"","loyaltyMember":"false","scid":"",
  "sessionID":param.hu,"state":"","userId":"anonymous","userStatus":"G","zipcode":""}};
  console.log('push start',dataLayer)
  try{
  if (window.adobeDataLayer !== null)
  window.adobeDataLayer.push(dataLayer);
  //window.adobeDataLayer[0]=dataLayer;
  console.log('push done')
  }
  catch(e) {
    console.log('error in push',e)
    
  }

  showMessage(dispatch,{severity: 'info', summary: '', sticky: false, detail: 'Redirecting to Shopping Bag'})
            
  fetch(fetchUrl+param.site+'/', sentData)
      .then(response => {
    
    window.add2cart='received'  
          if (response.ok) {
                return response.json();
              
          }
          else {
            showMessage(dispatch,{severity: 'error', summary: 'Error for Add to Cart: ', detail: 'No response'})
            
          }
      })
      .then(json => {

          if (Object.keys(json).length === 0) {
            showMessage(dispatch,{severity: 'error', summary: 'Error for Add to Cart: ', detail: 'Zero Size'})
          }
          //console.log('load json', json)]
          var json2;
          if (param['action'] === 'param') {  
            json2 = JSON.stringify(json);
            showMessage(dispatch,{severity: 'info', summary: 'Action: ' + param['action'], sticky: true, detail: json2})
            return
          } else if (param['action'] === 'request') {  



            





            json2 = JSON.stringify(json);
            showMessage(dispatch,{severity: 'info', summary: 'Action: ' + param['action'], sticky: true, detail: json2})
            return
        } else if (param['action'] === 'response') {  
          json2 = JSON.stringify(json);
          showMessage(dispatch,{severity: 'info', summary: 'Action: ' + param['action'], sticky: true, detail: json2})
          return
        } else if (param['action'] === 'redirect') {  
          if (json.code ==='00'){
          
            window.location = json.url}
          else {  
            if (json.url.includes('error.cart.limit'))
            showMessage(dispatch,{severity: 'info', summary: 'Our Shopping Bags will only hold 50 items at a time. If ordering over 50 items, please place a second order for the additional items. Thank you for your understanding.' , sticky: false, detail: ''})
            else 
            showMessage(dispatch,{severity: 'info', summary: 'Action code is ' + json.code   + ' ' + json.url, sticky: false, detail: json.url})
            return
          }
        }


          

          
      })
      .catch(errorMsg => {
          //error = true
          window.add2cart='received'  
          showMessage(dispatch,{severity: 'error',summary: 'Error for Add to Cart: ',detail: 'General Error'})
          
      //    console.log('error', errorMsg)
      });
  }
   
const updateQsku =(dispatch,params)=>{
  let headers = new Headers({
      //'Access-Control-Allow-Origin': '*'
  });
  let sentData = {
      method: 'GET', //opt.method,
      mode: 'cors',
      headers: headers

      //    body:opt.body || ''
  };
  
  let fetchUrl = UPDATE_QSKU_URL
     
 /*  fetch(fetchUrl + params, sentData)
      .then(response => {
          if (response.ok) {
            showMessage(dispatch,{severity: 'info', summary: '', sticky: false, detail: 'Updated Qsku'})
          }
          else {
            showMessage(dispatch,{severity: 'error', summary: 'Error', detail: response.text()})
          }
      })
      .catch(errorMsg => {
        console.log(errorMsg)
            showMessage(dispatch,{severity: 'error', summary: 'Error', detail: errorMsg})
       });
*/

fetch(fetchUrl + params, sentData)
    .then(response => {
        if (response.ok) {
            return response.text().then(text => {
                showMessage(dispatch, {severity: 'info', summary: '', sticky: false, detail: 'Updated Qsku'});
                window.location = text;
            });
        } else {
            return response.text().then(text => {
                showMessage(dispatch, {severity: 'error', summary: 'Error', detail: text});
                throw new Error(text); // Ensure the error is thrown to be caught in the catch block
            });
        }
    })
    .catch(error => {
        console.error('Error:', error);
        showMessage(dispatch, {severity: 'error', summary: 'Error', detail: error.message || error});
    });

}

  const mapStateToProps = (state, ownProps) => {
  

 
  var clistclistqty= getclist(state)
  var clist = clistclistqty[0]
  var clistqty = clistclistqty[1]
  //console.log('clistqty2',clistqty,state['acat'],state['e1'],hidelast)
  return {
    //price: ['9000','9082'].includes(state.sku)?state.price:calcPrice(state),
    price:calcPrice(state),
    chainsku:state.chain,
    view: state['view'],
    active_image_url: state['active_image_url'],
    max_views: state['max_view'],
    save_qsku: state.action == 'qsku',
    style: state['style'],
    lsbefore: state['lsbefore'],
    lsafter: state['lsafter'],
    lifeshown: state['lifeshown'],
    lifestyle: state['start_over_init']['lifestyle'],
    readyForAddToCart: checkOptions(state),
    readyForSession: checkSession(state),
    urlParams: addToCartOptions(state),
    charms:['9000','9082'].includes(state.sku),
    clistqty: clistqty,  
    properties:[{property:'1',value:'v1',value2:'x'},{property:'1',value:'v1',value2:'x'}],
    clist:clist,
    store:state.currentSite,
    charmreview:state.charmreview,
    hu: state['hu'],
    zsku: state['zsku'],
  
    chainmetal:state.m
    
  }
}



const mapDispatchToProps = (dispatch, ownProps) => ({
  onRefreshPrice: ( (json) => dispatch(state_update({attr:'pricedetails',value:json}))),
  onClickReview: ( () => dispatch(state_update({attr:'review',value:true}))),
  onShowCharm: ( () => dispatch(state_update({attr:'charmreview',value:true}))),
  onHideCharm: ( () => dispatch(state_update({attr:'charmreview',value:false}))),
  onNoOptionMessage: ( () => dispatch(state_update({attr:'message',
    value:{severity: 'info',summary: 'Warning: ',detail: MSG_NOT_READY_ADD_TO_CART}}))),
  onNoSessionMessage: ( () => dispatch(state_update({attr:'message',
    value:{severity: 'error',summary: 'Warning: ',detail: MSG_NO_SESSION1 + window.currentEnv + '.'+ window.currentSite + '.com' +MSG_NO_SESSION2}}))),
  onAddToCart: ( (param) => addToCart(dispatch,param)  ),
  onUpdateQsku: ( (param) => updateQsku(dispatch,param)  ),
  onDel: ( (val) => {
    //console.log('close OpenBox')
    dispatch(state_update({attr:'delcharm',value:val}))
  })
})



export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AiToolbar)


// WEBPACK FOOTER //
// ./src/layout/AiToolbarWrap.js